'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useState } from 'react';
import { Button, Container, Row, Col, ListGroup, Alert } from 'reactstrap';
import { MdCheckCircle, MdNotificationsNone, MdOutlineClose } from 'react-icons/md';
import { useUser } from 'shared/contexts/UserContext';
import JobTeaser from 'shared/components/JobTeaser';
import JobFacetSearch from 'shared/components/JobFacetSearch';
import JobSearchSaveModal from 'shared/components/JobSearchSaveModal';
import LoginModal from 'shared/components/LoginModal';
import AppLayout from '../../../components/AppLayout';
import { getI18nUtils } from 'shared/i18n/i18n-utils';

export default function Page({ dictionary, count, matches, facets, activeDomains, activeLocations, activeDivisions }) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { candidate } = useUser();
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const toggleSaveModal = () => setSaveModalOpen((prev) => !prev);
  const toggleLoginModal = () => setLoginModalOpen((prev) => !prev);

  const handleClickSave = () => {
    if (!candidate) toggleLoginModal();
    else toggleSaveModal();
  };

  // When a user has logged in via the loginModal this means this user tried
  // to save a search so login modal should be closed and save modal opened
  useEffect(() => {
    if (candidate && loginModalOpen) {
      toggleLoginModal();
      toggleSaveModal();
    }
  }, [candidate]);

  return (
    <>
      <LoginModal dictionary={dictionary} isOpen={loginModalOpen} toggle={toggleLoginModal} />{' '}
      {saveModalOpen && <JobSearchSaveModal dictionary={dictionary} toggle={toggleSaveModal} setSaveSuccess={setSaveSuccess} />}
      <AppLayout
        dictionary={dictionary}
        id="jobsPage"
        availableLocales={[
          { locale: 'nl', pathname: '/jobs/' },
          { locale: 'fr', pathname: '/jobs/' },
        ]}
        pageHeader={{
          backgroundUrl: '/headers/header_jobs.jpg',
          backgroundUrlMobile: '/headers/header_jobs_mobile.jpg',
          type: 'fullWidthImg',
        }}
      >
        <Container className="mt-5">
          <div className="d-flex justify-content-center">
            <h1 className="py-3 mb-5">{formatMessage({ id: 'jobs_page_h1' })}</h1>
          </div>

          <Row>
            <Col lg="4">
              <h2 className="mb-4 d-lg-none">{formatMessage({ id: 'jobs_filters' })}</h2>
              <div id="jobFacetSearch" className="sticky-top">
                <JobFacetSearch
                  dictionary={dictionary}
                  jobDomains={facets.jobDomains}
                  activeDomains={activeDomains}
                  locations={facets.locations}
                  activeLocations={activeLocations}
                  divisions={facets.division}
                  activeDivisions={activeDivisions}
                />
                <Button
                  outline
                  onClick={handleClickSave}
                  className="jobs-button aside d-none d-lg-flex align-items-center justify-content-center mb-5 w-100"
                >
                  <MdNotificationsNone className="me-2" />
                  <div>{formatMessage({ id: 'save_jobsearch' })}</div>
                </Button>
              </div>
            </Col>
            <Col lg="8">
              {saveSuccess && (
                <Alert
                  type="success"
                  isOpen={saveSuccess}
                  className="mySynergie successMessage d-flex justify-content-start align-items-center mb-4"
                >
                  <MdCheckCircle size={22} className="me-3" />
                  <div className="me-auto">
                    <p className="mb-1">
                      <strong>{formatMessage({ id: 'saved_jobsearch' })}</strong>
                    </p>
                    <p className="mb-0">{formatMessage({ id: 'save_jobsearch_success' })}</p>
                  </div>
                  <Button outline onClick={() => setSaveSuccess(false)} className="button-mysynergie-icon light">
                    <MdOutlineClose size={22} color="#0f5132" />
                  </Button>
                </Alert>
              )}
              <h2 className="my-4 d-lg-none">
                <strong>{count}</strong> {formatMessage({ id: 'jobs_found' })}
              </h2>
              {matches && (
                <ListGroup>
                  {matches.map((job) => (
                    <JobTeaser dictionary={dictionary} job={job} key={job.id} />
                  ))}
                </ListGroup>
              )}
            </Col>
          </Row>
        </Container>
      </AppLayout>
    </>
  );
}
